import * as React from "react";
import styled from "styled-components";
import { ConstBreakPoint } from "../../../../../config/styles_const/styles_const";

interface IProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {}

const YearWrapperDefault: React.FC<IProps> = (props) => {
  const { ...DivProps } = props;

  return <div {...DivProps} />;
};

const YearWrapper = styled(YearWrapperDefault)`
  width: 120px;
  margin-right: 50px;
  margin-bottom: 10px @media screen and (min-width: ${ConstBreakPoint.Default}) {
    width: 300px;
    margin-right: 50px;
    margin-bottom: 0;
  }
`;

export default YearWrapper;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/wrapper/datepicker_wrapper/year_wrapper.tsx